import { TechDocPage, TechDocWizardPage } from '../containers/pages';
import { PRIMERA_VIDEO_URL } from '../constants';
import { powerupInit } from './primeraPagesConfigCommon';
import { gettingStarted } from './nimblePrimeraPageConfigComm';

export const pagesConfig = [
  ...gettingStarted(),
  {
    path: '/physical-install',
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: '/physical-install/unbox',
    submenuItems: [
      {
        path: '/physical-install/unbox',
        menuText: 'unbox',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/physical-install/install',
        menuText: 'install',
        exact: true,
        redirectTo: '/physical-install/install/1',
      },
      {
        path: '/physical-install/install/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'install',
        pageProps: {
          steps: [
            {
              videoUrl: PRIMERA_VIDEO_URL.FIELD_RACKARRAY_STEP1,
            },
            {
              videoUrl: PRIMERA_VIDEO_URL.FIELD_RACKARRAY_STEP2,
            },
            {
              videoUrl: PRIMERA_VIDEO_URL.FIELD_RACKARRAY_STEP3,
            },
            {
              videoUrl: PRIMERA_VIDEO_URL.FIELD_RACKARRAY_STEP4,
            },
          ],
        },
      },
      {
        path: '/physical-install/cable',
        menuText: 'cable',
        exact: true,
        redirectTo: '/physical-install/cable/1',
      },
      {
        path: '/physical-install/cable/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {},
            {
              videoUrl: PRIMERA_VIDEO_URL.FACTORY_CABLE_STEP1,
            },
            {
              videoUrl: PRIMERA_VIDEO_URL.FACTORY_CABLE_STEP2,
            },
            {},
          ],
        },
      },
    ],
  },
  ...powerupInit,
];
